module.exports = __webpack_public_path__ + "static/media/sf_1700_gray.71f04bc0d8479c676a9ade99b3153194.png";